export default __webpack_public_path__ + "static/media/ConfigurationIcon.7e8bf413.svg";